import React from 'react';
import { Calendar, Clock, MapPin, Film, MessageCircle, Dumbbell, Users, Trophy } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { useLanguage } from '../context/LanguageContext';

const Program = () => {
  const { t } = useLanguage();
  const schedule = [
    {
      day: t('program_day_saturday'),
      date: t('program_date_saturday'),
      color: 'orange',
      events: [
        /* WORKSHOPS HIDDEN - TO BE RESTORED LATER
        {
          time: '10h00 - 11h30',
          title: t('program_sat_workshop1'),
          description: t('program_sat_workshop1_desc'),
          location: 'Gymnase Jean Marion, 1 rue Marius Chanteur, 21000 Dijon',
          icon: <Dumbbell size={20} />,
          badge: t('badge_paid'),
          badgeColor: 'orange',
          link: 'https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-stage-sarah-bee'
        },
        {
          time: '11h45 - 13h15',
          title: t('program_sat_workshop2'),
          description: t('program_sat_workshop2_desc'),
          location: 'Gymnase Jean Marion, 1 rue Marius Chanteur, 21000 Dijon',
          icon: <Dumbbell size={20} />,
          badge: t('badge_paid'),
          badgeColor: 'orange',
          link: 'https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-stage-sarah-bee'
        },
        {
          time: '13h30 - 15h00',
          title: t('program_sat_workshop3'),
          description: t('program_sat_workshop3_desc'),
          location: 'Gymnase Jean Marion, 1 rue Marius Chanteur, 21000 Dijon',
          icon: <Dumbbell size={20} />,
          badge: t('badge_paid'),
          badgeColor: 'orange',
          link: 'https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-stage-sarah-bee'
        },
        {
          time: '15h15 - 16h45',
          title: t('program_sat_wings'),
          description: t('program_sat_wings_desc'),
          location: 'Gymnase Jean Marion, 1 rue Marius Chanteur, 21000 Dijon',
          icon: <Dumbbell size={20} />,
          badge: t('badge_paid'),
          badgeColor: 'orange',
          link: 'https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-stage-sarah-bee'
        },
        END OF WORKSHOPS */
        {
          time: '14h00 - 20h00',
          title: t('program_sun_boty'),
          description: t('program_sun_boty_desc'),
          location: 'Gymnase Jean Marion, 1 rue Marius Chanteur, 21000 Dijon',
          icon: <Trophy size={20} />,
          badge: t('badge_paid'),
          badgeColor: 'orange',
          featured: true
        }
      ]
    }
  ];

  return (
    <section id="program" className="py-20 bg-zinc-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('program_title')}
            </h2>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-6"></div>
            <p className="text-gray-400 text-lg">
              {t('program_subtitle')}
            </p>
          </div>

          {/* Schedule */}
          <div className="space-y-12">
            {schedule.map((day, dayIndex) => (
              <div key={dayIndex} className="relative">
                {/* Day Header */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
                  <div className="flex items-center gap-4">
                    <div className="relative">
                      <div className={`w-16 h-16 rounded-full bg-${day.color}-500/20 border-4 border-${day.color}-500 flex items-center justify-center`}>
                        <Calendar className={`text-${day.color}-500`} size={24} />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-3xl font-bold text-white">{day.day}</h3>
                      <p className="text-gray-400 text-lg">{day.date}</p>
                    </div>
                  </div>
                  
                  {/* Buttons for Saturday - HIDDEN WHILE WORKSHOPS ARE ON PAUSE
                  {day.day === t('program_day_saturday') && (
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLScxTVCxVXdR6hZarUZIdYoGWaFebRMCBGWxTV4-YR9RRO6Nqw/viewform?usp=dialog"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-300 font-medium text-sm text-center"
                      >
                        {t('program_sat_form_button')}
                      </a>
                      <a
                        href="https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-stage-sarah-bee"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors duration-300 font-medium text-sm text-center"
                      >
                        {t('program_sat_buy_button')}
                      </a>
                    </div>
                  )}
                  END OF WORKSHOP BUTTONS */}
                </div>

                {/* Events */}
                <div className="ml-8 border-l-2 border-zinc-700 pl-8 space-y-6">
                  {day.events.map((event, eventIndex) => (
                    <Card
                      key={eventIndex}
                      className={`bg-zinc-800/50 backdrop-blur-sm border-zinc-700 hover:border-red-500 transition-all duration-300 ${
                        event.featured ? 'border-red-500 shadow-lg shadow-red-500/20' : ''
                      }`}
                    >
                      <div className="p-6">
                        <div className="flex flex-col md:flex-row md:items-start gap-4">
                          {/* Time */}
                          <div className="flex items-center gap-2 text-red-500 font-bold min-w-[140px]">
                            <Clock size={20} />
                            <span>{event.time}</span>
                          </div>

                          {/* Content */}
                          <div className="flex-1">
                            <div className="flex items-start gap-3 mb-2">
                              <div className="text-red-500 mt-1">{event.icon}</div>
                              <div className="flex-1">
                                <h4 className="text-xl font-bold text-white mb-2 flex items-center gap-2">
                                  {event.title}
                                  {event.badge && (
                                    <Badge className={`${
                                      event.badgeColor === 'green' 
                                        ? 'bg-green-600 text-white' 
                                        : 'bg-orange-500 text-white'
                                    }`}>
                                      {event.badge}
                                    </Badge>
                                  )}
                                </h4>
                                <p className="text-gray-400 mb-3">{event.description}</p>
                                <div className="flex items-center gap-2 text-gray-500 text-sm mb-3">
                                  <MapPin size={16} />
                                  <span>{event.location}</span>
                                </div>
                                {event.link && (
                                  <a
                                    href={event.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors duration-300 font-medium text-sm"
                                  >
                                    Réserver ce stage
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Program;
